import { parsePastedNames } from '~/utils/pastedNames'

/**
 * The media names held in a pasted blob, in the order they were pasted.
 *
 * Media names may contain spaces, so the shared splitter's default trim is exactly right here: it
 * separates on the delimiters a spreadsheet or an inline list actually uses and leaves the name alone.
 */
export const parseMediaNames = (text: string): string[] => parsePastedNames(text)

/**
 * The rows a paste at `index` leaves behind: the pasted rows take the row they were dropped on and
 * spill into fresh rows under it, and whatever the user had already typed below is pushed down rather
 * than overwritten.
 *
 * Generic in the row, because a media row is a name *and* an environment: threading the paste through
 * `string[]` would rebuild the rows below it from their names alone and silently reset their env.
 *
 * Kept apart from the component so the spill is a pure function of the rows and the paste — it is the
 * part with an off-by-one to get wrong, and the part worth pinning in a test.
 */
export const rowsAfterPaste = <T>(rows: T[], index: number, pasted: T[]): T[] => [...rows.slice(0, index), ...pasted, ...rows.slice(index + 1)]
